// @todo Jak już przeniesiemy w całości projekt na VUE, ten plik powinien zostać usunięty. Na tą chwilę trzyma funkcje, które są wymagane do działania pomiędzy vue, a natywną wersją aplikacji

export function updateWalletInformation(data) {
    if (data.wallet_id) {
        const container = document.querySelector(`.tenant-account-wallet-tab [data-wallet-id="${data.wallet_id}"]`)
        if (container) {
            const walletElement = document.querySelector(`.nav-tenant-accounts-wallet [data-wallet-id="${data.wallet_id}"]`)
            const walletBalanceElement = walletElement.querySelector('[data-wallet-balance]')
            const balanceElement = container.querySelector('[data-wallet-balance]')
            const advanceElement = container.querySelector('[data-wallet-advance]')
            const depositElement = container.querySelector('[data-wallet-deposit]')
            const depositPaidElement = container.querySelector('[data-wallet-deposit-paid]')
            const depositToPayElement = container.querySelector('[data-wallet-deposit-to-pay]')

            walletBalanceElement.innerText = formattedMoney(data.balance, 2, data.currency)
            walletBalanceElement.classList.remove('text-danger')
            if (data.balance < 0) {
                walletBalanceElement.classList.add('text-danger')
            }

            balanceElement.innerText = formattedMoney(data.balance, 2, data.currency)
            balanceElement.classList.remove('text-danger')
            if (data.balance < 0) {
                balanceElement.classList.add('text-danger')
            }

            advanceElement.innerText = formattedMoney(data.advance, 2, data.currency)
            advanceElement.classList.remove('text-danger')
            if (data.advance < 0) {
                advanceElement.classList.add('text-danger')
            }

            depositPaidElement.innerText = formattedMoney(data.deposit_paid, 2, data.currency)
            depositToPayElement.innerText = formattedMoney(data.deposit_to_pay, 2, data.currency)
            depositElement.classList.remove('text-danger')
            if (data.deposit_to_pay - data.deposit_paid > 0) {
                depositElement.classList.add('text-danger')
            }
        }
    }

    if (data.hasOwnProperty('refresh_wallets')) {
        document.dispatchEvent(new CustomEvent('refresh-wallets', { detail: data.wallet_id }))
        document.dispatchEvent(new CustomEvent('refresh-tenant-wallets'))
        document.dispatchEvent(new CustomEvent('refresh-wallet', { detail: data.wallet_id }))
    }

    window.dispatchEvent(new CustomEvent(`update-${data.table_type}-show`, { detail: data.user_id }))
}
